import React from "react"
import { Box } from "@carrotfertility/carotene-core"
import type { TwoColumnLayoutNode } from "../renderer/types"
import { ContentList } from "./content-item"

export function TwoColumnLayoutContent({ content }: { content: TwoColumnLayoutNode }) {
  return (
    <Box
      display="flex"
      gap={(theme) => theme.spacing(theme.tokens.spacing.md)}
      flexWrap="wrap"
      sx={(theme) => ({
        "& > *": { inlineSize: { xs: "100%", md: `calc(50% - ${theme.spacing(theme.tokens.spacing.md)})` } }
      })}
    >
      <ContentList contents={content.content} />
    </Box>
  )
}
